/* eslint-disable no-param-reassign */
import { CONVERSATION_MUTATIONS } from '@/state/mutation-types'

export default {
  state: {
    draftMessage: null,
  },
  mutations: {
    [CONVERSATION_MUTATIONS.SET_DRAFT_MESSAGE](state, message) {
      state.draftMessage = message
    },
  },
  getters: {
    draftMessage: (state) => state.draftMessage,
  },
}
